import React from 'react';
import { Box, Skeleton } from '@mui/material';
const ReportSectionLoading = ({ count = 3}) => {

  return (
    <Box
      sx={{
        display: 'grid',
        flexDirection: 'column',
        gap: '16px',
        rowGap: '24px',
        columnGap: '24px',
        alignSelf: 'stretch',
        gridTemplateColumns: {
          xs: '1fr',
          sm: 'repeat(2, minmax(0, 1fr))',
          md: 'repeat(3, minmax(0, 1fr))',
          xl: 'repeat(4, minmax(0, 1fr))'
        },
        mt: '24px'
      }}>
      {Array.from({ length: count }).map((_, idx) => (
        <Box
          key={`report-card-skeleton-${idx}`}
          sx={{
            border: '1px solid #E0E0E0',
            borderRadius: '12px',
            width: '100%',
            height: '245px',
            p: '24px',
            boxSizing: 'border-box',
            background: '#FFF',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'space-between'
          }}>
          <Box>
            <Skeleton variant="rounded" width={80} height={24} sx={{ borderRadius: '12px', mb: 2 }} />
            <Skeleton variant="text" width="70%" height={28} sx={{ mb: 0.5 }} />
            <Skeleton variant="text" width="90%" height={20} />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              mt: 3
            }}>
            <Skeleton variant="rounded" width={20} height={24} sx={{ borderRadius: '4px' }} />
            <Skeleton variant="rounded" width={90} height={32} sx={{ borderRadius: '16px' }} />
          </Box>
        </Box>
      ))}
    </Box>
  );
};
export default ReportSectionLoading;
